import React, { useEffect, useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay } from "swiper/modules";
import "swiper/css";
import "swiper/css/autoplay";
import "./client.css";

// Client Logos
import img1 from "../../assets/images/clients/client1.png";
import img2 from "../../assets/images/clients/client2.png";
import img3 from "../../assets/images/clients/client3.png";
import img4 from "../../assets/images/clients/client4.png";
import img5 from "../../assets/images/clients/client5.png";
import img6 from "../../assets/images/clients/client6.png";
import img7 from "../../assets/images/clients/client7.png";
import img8 from "../../assets/images/clients/client8.png";
import img9 from "../../assets/images/clients/client9.png";
import img10 from "../../assets/images/clients/client10.png";
import img11 from "../../assets/images/clients/client11.png";
import img12 from "../../assets/images/clients/client12.png";
import img13 from "../../assets/images/clients/client13.png";
import img14 from "../../assets/images/clients/client14.png";
import img15 from "../../assets/images/clients/client15.png";
import img16 from "../../assets/images/clients/client16.png";
import img17 from "../../assets/images/clients/client17.png";
import img18 from "../../assets/images/clients/client18.png";
import img19 from "../../assets/images/clients/client19.png";
import img20 from "../../assets/images/clients/client20.png";
import img21 from "../../assets/images/clients/client21.png";
import img22 from "../../assets/images/clients/client22.png";
import img23 from "../../assets/images/clients/client23.png";
import img24 from "../../assets/images/clients/client24.png";

const Client = () => {
  const [isGray, setIsGray] = useState(true);

  // After 1 hour, switch logos to original color
  useEffect(() => {
    const timer = setTimeout(() => {
      setIsGray(false);
    }, 60 * 60 * 1000); // 1 hour
    return () => clearTimeout(timer);
  }, []);

  // Array of imported logos
  const logos = [
    img1, img2, img3, img4, img5, img6,
    img7, img8, img9, img10, img11, img12,
    img13, img14, img15, img16, img17, img18,
    img19, img20, img21, img22, img23, img24,
  ];

  return (
 <section className="client-section">
  
      <h2 className="client-title">Our Valued Clients</h2>

      <div className="client-container">
       <Swiper
  modules={[Autoplay]}
  spaceBetween={20}
  loop={true}
  autoplay={{
    delay: 1500,
    disableOnInteraction: false,
  }}
  speed={800}
  breakpoints={{
    1200: { slidesPerView: 6 },
    992: { slidesPerView: 5 },
    768: { slidesPerView: 4 },
    576: { slidesPerView: 3 },
    0: { slidesPerView: 2 },
  }}
>
  {logos.map((logo, index) => (
    <SwiperSlide key={index}>
      <div className="client-logo-box" style={{ "--bg": `url(${logo})` }}>
        <img src={logo} alt={`Client ${index + 1}`} />
      </div>
    </SwiperSlide>
  ))}
</Swiper>

      </div>
    </section>
  );
};

export default Client;
